module.exports = __webpack_public_path__ + "static/media/product14.16f56289.jpg";